<template>
  <b-dropdown :id="`dropdown-${application.id}`" right class="dropdown application-button" :toggle-class="'btn-default'">
    <template #button-content>
      <i class="fa fa-bars"/>
    </template>
    <slot name="prevItems"></slot>
    <template v-for="(item, key) in items">
      <b-dropdown-item
        :key="key"
      >
        <a
           :style="{cursor: 'pointer'}"
           @click="item.esignature === '1' ? getSigner(application, item) : approvalCommand(application, item)"
        >
          <img class="menu-item-img" :src="iconsPath + item.icon" width="20px" height="22px" alt=""/>
          {{ item.command_name }}
        </a>
      </b-dropdown-item>
    </template>
    <slot name="lastItems"></slot>
  </b-dropdown>
</template>

<script>
export default {
  name: 'ActionListMenu',
  props: {
    getSigner: Function,
    approvalCommand: Function,
    baseUrl: String,
    items: {
      type: [Object, Array],
      default: () => {}
    },
    application: Object
  },

  computed: {
    equalSubdivisions () {
      return this.user?.subdivisions?.find(x => x.subdivision_id === this.application.subdivision_id) !== undefined
    },

    iconsPath () {
      return this.baseUrl + '/img/icons/statuses/'
    }
  }
}
</script>
